var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('CreateCampaignSetupsHeader',{on:{"saveCampaignSetupDraft":_vm.saveDraftCampaignSetup}})],1)]),_c('div',[_c('CreateCampaignSetupsWrapper',{ref:"campaignSetupsWrapper"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }